// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"1bda52e2","158":"99aa875f","350":"0572445e","512":"dc567b1d"}[chunkId] + ".chunk.js";
};